"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _editorialContentGrid = _interopRequireDefault(require("../styles/editorial-content-grid.css"));

var _editorialContentGrid2 = _interopRequireDefault(require("./editorial-content-grid.props/editorial-content-grid.defaultProps"));

var _editorialContentGrid3 = _interopRequireDefault(require("./editorial-content-grid.props/editorial-content-grid.propTypes"));

var dataUtils = new _mmcDataUtilities["default"]();
var renderEmptyString = dataUtils.renderEmptyString,
    appendImageTransforms = dataUtils.appendImageTransforms;
var imageWidth = 960;

var ImageWrapper = function ImageWrapper(_ref) {
  var image = _ref.image,
      theme = _ref.theme;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.marginBottom40
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _editorialContentGrid["default"].backgroundImage,
    style: {
      backgroundImage: "url(\"" + appendImageTransforms(renderEmptyString(image.image), imageWidth) + "\")"
    },
    role: "img",
    "aria-label": renderEmptyString(image.altText),
    title: renderEmptyString(image.altText)
  }));
};

ImageWrapper.displayName = 'ImageWrapper';
ImageWrapper.defaultProps = {
  image: _editorialContentGrid2["default"].columns[0].image
};
var _default = ImageWrapper;
exports["default"] = _default;